import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "ttc-rate";
const STALE_DAYS = 7;

export const money = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
export const inr = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Math.round(n));

const StoreContext = createContext({ rate: null, shipping_inr: null, rate_updated_at: null, refreshFailed: false });

export function StoreProvider({ children }) {
  const [store, setStore] = useState(() => ({ ...JSON.parse(localStorage.getItem(CACHE_KEY) || "{}"), refreshFailed: false }));
  useEffect(() => {
    const load = () =>
      axios
        .get(`${API}/settings/store`)
        .then((r) => {
          const next = { rate: r.data.usd_inr_rate, shipping_inr: r.data.shipping_inr, rate_updated_at: r.data.rate_updated_at };
          localStorage.setItem(CACHE_KEY, JSON.stringify(next));
          setStore({ ...next, refreshFailed: false });
        })
        .catch(() => setStore((s) => ({ ...s, refreshFailed: true })));
    load();
    const timer = setInterval(load, 5 * 60 * 1000);
    window.addEventListener("focus", load);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", load);
    };
  }, []);
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export const useStore = () => useContext(StoreContext);

export function Price({ usd, from = false, className = "", testId }) {
  const { rate } = useStore();
  return (
    <span className={`price ${className}`} data-testid={testId}>
      <strong>
        {from && <em>From </em>}
        {money(usd)}
      </strong>
      <small className="price-inr" data-testid={testId && `${testId}-inr`}>
        {rate ? `Approx. ${inr(usd * rate)}` : "INR rate unavailable"}
      </small>
    </span>
  );
}

export function RateNote({ rate: fixedRate, updatedAt: fixedUpdated }) {
  const store = useStore();
  const rate = fixedRate ?? store.rate;
  const updated = fixedUpdated ?? store.rate_updated_at;
  if (!rate) return <p className="rate-note warn" data-testid="rate-note">Exchange rate unavailable — INR amounts will be confirmed at checkout.</p>;
  const days = updated ? (Date.now() - new Date(updated).getTime()) / 864e5 : null;
  return (
    <p className={`rate-note ${store.refreshFailed || days > STALE_DAYS ? "warn" : ""}`} data-testid="rate-note">
      ₹{Number(rate).toFixed(2)} per $1 · store rate
      {updated ? ` · updated ${new Date(updated).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}` : " · update time not recorded"}
      {days > STALE_DAYS && ` · not updated in ${Math.floor(days)} days`}
      {store.refreshFailed && " · couldn't refresh, showing last known rate"}
    </p>
  );
}
